import Head from 'next/head'
import Image from 'next/image'
import { Inter } from 'next/font/google'
import styles from '../styles/Home.module.css'
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import NextLink from 'next/link';

const inter = Inter({ subsets: ['latin'] })

export default function Home() {
  return (
    <main className="min-h-screen max-w-full overflow-x-hidden box-border flex flex-col justify-between items-center">
      <Navbar />      
      <article className="prose bg-white p-5 m-5 md:m-0 md:p-10 rounded">
        <h3 className="text-center mb-0">Privacy Policy</h3>
        <h4 className="text-center mt-0">Last Updated: 2023-08-31</h4>
        <div className="bg-slate-100 p-2 rounded">
            <h4 className='mt-0'>TL;DR...</h4>
            <p className='mb-0'>
                If you are wondering what happens to your files when you upload them, the answer is simple: <em>We 
                don&apos;t store them.</em> Our AI models run entirely in the browser, meaning that everything happens
                locally on your machine.  After you close the browser or refresh the page, the uploaded file(s) are cleared from the browser&apos;s memory. There is no need for us to offload images to an external server, or process them 
                in any capacity, so we simply don&apos;t.
            </p>
            <p className='mb-0'>
            If you want to learn more, continue reading our privacy policy below.


            </p>
        </div>
        <br></br>
        <h5 className="font-bold text-lg">1. We process your personal data as follows</h5>
        <h5 className="font-bold text-sm mt-2">1.1 Information you provide with us directly</h5>
        <p>
        Certain parts of our Services may ask you to provide personal data voluntarily: for example, we may ask you to 
        provide your name, email address and marketing email preferences in order to register an account with us and/or 
        to subscribe to marketing communications from us. The data that you are asked to provide, and the reasons why you
        are asked to provide it, will be made clear to you at the point we ask you to provide your data.
        </p>
        <h5 className="font-bold text-sm mt-2">1.2 Information we receive from third parties</h5>
        <p>
        We may receive information about you from third parties. For example, if you access our Services through a 
        third-party connection or log-in (e.g. through Google), that third party may pass certain information to us. 
        This information could include, for example, your name and email address, 
        and any other information that you have permitted the third party to share with us. You should always review, 
        and if necessary, adjust your privacy settings on third-party services before linking or connecting them to 
        StyleSense.
        </p>
        <h5 className="font-bold text-sm mt-2">1.3 Information we collect as you use our service</h5>
        <p>
        Our web server collects data that your Internet browser communicates to us, including the IP address of the requesting computer, 
        location data, device or app data, browser or operating system, and the website from which the request was made 
        (should the access take place via a referring link). We also collect information 
        about how you have interacted with our website, such as the pages you view, the links you click, the features you use and session duration.
        </p>
        <h5 className="font-bold text-lg">2. Sharing your personal data</h5>
        <p>
At this time, we only disclose your data to our service providers and partners who provide data hosting and/or data processing services to us 
(for example, services to support the deployment of, provide functionality on, or help to enhance the security of our websites or provide analytics tagging to us) .            
        </p>
        <h5 className="font-bold text-lg">3. Changes to this policy</h5>
        <p>
        We may update this policy from time to time to reflect our current practice and ensure compliance with applicable laws. When we post changes to this policy, we will revise the “Last Updated” date at the top of this policy. If we make any material changes to the way we collect, use, store and/or share your personal data, we will take appropriate measures to notify you. We recommend that you check this page from time to time to inform yourself of any changes.
        </p>
        <h5 className="font-bold text-lg">4. How to contact us</h5>
        <p>
        If you have any questions, suggestions or concerns about our use of your personal data or this privacy policy, please contact us at:
        <ul>
            <li>support@stylesense.io</li>
        </ul>


        </p>
      </article>
      <Footer />
    </main>
  )
}